import { Route } from 'react-router-dom';
import { RequireCustomerAdmin } from '../../components/RequireCustomerAdmin.js';
import { PlanningBackupPage } from './pages/PlanningBackupPage.js';
import { PlanningErDiagramPage } from './pages/PlanningErDiagramPage.js';
import { PlanningGovernancePage } from './pages/PlanningGovernancePage.js';
import { PlanningScenarioPlanningPage } from './pages/PlanningScenarioPlanningPage.js';
import { PlanningSnapshotPage } from './pages/PlanningSnapshotPage.js';
import { PlanningVisualizationPage } from './pages/PlanningVisualizationPage.js';

/**
 * Planning — six pages, all real (engine-backed where applicable
 * or client-derived). Phase B richens the visualizations with
 * timeseries + a real charting library.
 */
export function planningRoutes(): JSX.Element {
  return (
    <>
      <Route path="/planning" element={<PlanningVisualizationPage />} />
      <Route path="/planning/snapshot" element={<PlanningSnapshotPage />} />
      <Route path="/planning/er-diagram" element={<PlanningErDiagramPage />} />
      <Route path="/planning/governance" element={<PlanningGovernancePage />} />
      <Route path="/planning/scenario-planning" element={<PlanningScenarioPlanningPage />} />
      {/*
        Backup + Restore share one page component (same data shape, same
        polling, same delete + create dialogs). The URL drives which tab
        opens by default — see `PlanningBackupPage`'s `useLocation()` /
        `useNavigate()` pairing.
      */}
      <Route
        path="/planning/backup"
        element={
          <RequireCustomerAdmin>
            <PlanningBackupPage />
          </RequireCustomerAdmin>
        }
      />
      <Route
        path="/planning/restore"
        element={
          <RequireCustomerAdmin>
            <PlanningBackupPage />
          </RequireCustomerAdmin>
        }
      />
    </>
  );
}
